import axios from "axios";
import CryptoJS from "crypto-js";
import packageJson from '../../../package.json';

async function AxiosLibWithHeader2(value, pathURI) {

    const Secretkey = value.keys.Secretkey;
    const d = new Date();
    const tstamp = d.getTime() / 1000;


    const body = value.body;

    const payloadTmp = body;
    //var trimmed_payload = payloadTmp.toString().replace(/\s+/g, '');
    const trimmed_payload = JSON.stringify(payloadTmp).replace(/\s+/g, '');
    const base64 = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(trimmed_payload));
    //console.log(base64);
    const signature_raw = tstamp + '|<->|' + base64;
    //console.log(signature_raw);
    const signature_bytes = CryptoJS.HmacSHA256(signature_raw, Secretkey);
    //console.log(signature_bytes);
    const signature = CryptoJS.enc.Base64.stringify(signature_bytes);
    const headers = {
        "App-Id": value.keys.AppId,
        "App-Env": value.keys.AppEnv,
        "App-Signature": signature,
        "App-Timestamp": tstamp,
        'Content-Type': 'application/json'
    }

    const config = {
        method: 'post',
        url: packageJson.system_param.ApiBackendURI + pathURI,
        headers,
        data: body
    };

    let response = await axios(config)
        .then(function (response) {
            var result = response.data;
            return result;
        })
        .catch(function (error) {
            const message = "Failed to connect to server'. " + error.message;
            const result = { "error": message, "redirect": false }
            return result;
        })
    return response;
}

export const RequestOthURL = async (config) => {
    let response = await axios.request(config)
        .then((response) => {
            console.log(response.data);
            return response.data;
        })
        .catch((error) => {
            console.log(error);
            const message = "Failed to connect to server'. " + error.message;
            const result = { "error": message, "redirect": false }
            return result;
        });

    return response;
}

export default AxiosLibWithHeader2;